import { employeeExpectationsRequest } from "~/pages/Editor/EditorStaff/requests/employeeExpectationsRequest";

export async function deleteEmployeeExpectations(data: { instanceId: string }) {
  return employeeExpectationsRequest("DELETE", data);
}
